import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { DataDescription, Paragraph } from './Typography';

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Commentary = ({ phrase, emptyState }) => (
  <Wrapper>
    {emptyState ? (
      <Paragraph className="text-center mb-3" faded>{phrase}</Paragraph>
    ) : (
      <>
        <DataDescription large>Average for all players</DataDescription>
        <DataDescription large light>
          {phrase}
        </DataDescription>
      </>
    )}
  </Wrapper>
);

Commentary.defaultProps = {
  emptyState: false,
};

Commentary.propTypes = {
  phrase: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  emptyState: PropTypes.bool,
};

export default Commentary;
